/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileUploadResult } from '../../models/file-upload-result';

export interface ImagesControllerUploadFile$Params {
}

export function imagesControllerUploadFile(http: HttpClient, rootUrl: string, params?: ImagesControllerUploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUploadResult>> {
  const rb = new RequestBuilder(rootUrl, imagesControllerUploadFile.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileUploadResult>;
    })
  );
}

imagesControllerUploadFile.PATH = '/images/uploadFile';
